import * as React from 'react';
import styles from '../styles/wizards/AddSubstageWizard.scss';
import AddSubstageIcon from '../assets/images/add-stage-60x60.svg';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { createSubstage } from '../redux/actions/table/substages';
import AddSubstageForm from '../forms/add_substage_wizard/AddSubstageForm';

const AddSubstageWizard = ({ onClose, stage_id }) => {
  const _handleSubmit = (formData) => {
    return validateForm(
      createSubstage(formData).then(({ response }) => {
        setTableParams('substages', {
          wizard_active: false,
        });

        onClose();

        setNotification(__('wizard.add-substage.notification.success'));
      })
    );
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.add-substage.title.create-new')}</span>
          <span>{__('wizard.add-substage.subtitle.create-new')}</span>
        </div>
        <div className={styles.right}>
          <AddSubstageIcon />
        </div>
      </div>
      <div className={styles.body}>
        <AddSubstageForm
          onSubmit={_handleSubmit}
          initialValues={{
            stage_id: stage_id,
            status: '0',
            duration: '60',
          }}
        />
      </div>
    </>
  );
};

export default withRouter(
  mapStateToProps((state) => ({
    table: state.table['substages'],
    stage_id: _.first(state.table['stages'].data).id,
  }))(AddSubstageWizard)
);
